// Frontend-only app-status types with no Swift backing (re-homed from the former
// hand-written AppStatus/AppNMEAStatus mirrors during the #627 TypeGen migration).

export enum INMEAStatusMode {
  recordingAutoEntries = "recordingAutoEntries",
  recording = "recording",
  notRecording = "notRecording",
}
